import { authHeader } from "../helpers/auth-header";

export default function oauthFetch(url: RequestInfo, init?: RequestInit): Promise<Response> {
    if (!init || !init.headers) {
        return fetch(url, init);
    }

    const token = authHeader();

    const newInit: RequestInit = {
        ...init,
        credentials: "omit",
        headers: { ...init.headers, Authorization: token },
        mode: "cors"
    };
    return fetch(url, newInit);
}


// WEBPACK FOOTER //
// ./src/helpers/oauth_fetch.ts